import styled from "@emotion/styled";

import Icon from "shared/components/Icon";

export const BaseDeleteIcon = styled(Icon.BaseDeleteIcon)`
  cursor: pointer;
`;
